import FetchFactory from '../factory';
import type { OrderReceiptModel } from '~/models/order/OrderReceipt.api.model';

const CONTROLLER_PATH = '/api-electra/OrderReceipt';
const ENDPOINT_PATH = `${CONTROLLER_PATH}/GetOrderReceipt`;

class OrderReceipt extends FetchFactory<any> {
  async getReceipt(orderId: number): Promise<any> {
    return await this.get(`${ENDPOINT_PATH}/${orderId}`);
  }

  async getReceiptWithGuid(
    orderGuid: MaybeRef<string>,
  ): Promise<OrderReceiptModel> {
    const randomNumber = Math.random() * 10;
    return await this.get(ENDPOINT_PATH, {
      params: {
        orderGuid: unref(orderGuid),
        updateHasSentPurchaseEvent: true,
        hash: randomNumber,
      },
    });
  }

  async getReceiptWithSsn(
    orderId: string,
    ssn: string,
  ): Promise<OrderReceiptModel> {
    return await this.get(ENDPOINT_PATH, {
      params: {
        orderId: orderId,
        ssn: ssn,
      },
    });
  }

  async getReceiptWithZipCode(
    orderId: string,
    zipCode: string,
  ): Promise<string> {
    return await this.get(`${CONTROLLER_PATH}/GetOrderStatusLink`, {
      params: {
        orderId: orderId,
        zipCode: zipCode,
      },
    });
  }

  async getReceiptWithSsnAndGuid(
    orderGuid: string,
    ssn: string,
  ): Promise<OrderReceiptModel> {
    return await this.get(ENDPOINT_PATH, {
      params: {
        orderGuid: orderGuid,
        ssn: ssn,
      },
    });
  }

  async getOrderStatusLinkWithOrderIdAndSSN(
    orderId?: string,
    ssn?: string,
  ): Promise<string> {
    return await this.get(`${CONTROLLER_PATH}/GetOrderStatusLink`, {
      params: {
        orderId: orderId,
        ssn: ssn,
      },
    });
  }

  async getOrderContractSummaryPDF(orderGuid: string): Promise<File> {
    return await this.get(`${CONTROLLER_PATH}/GetContractSummary`, {
      params: {
        orderGuid,
      },
    });
  }

  async customerIsAllowedToSeeOrderReceipt(
    orderGuid: string,
    customerGuid?: string,
  ): Promise<boolean> {
    return await this.get(
      `${CONTROLLER_PATH}/AllowedToViewReceipt?orderGuid=${orderGuid}${customerGuid ? `&identifier=${customerGuid}` : ''}`,
    );
  }
}

export default OrderReceipt;
